import cn from "classnames";
import { useEffect } from "react";

import useOutsideClick from "helpers/useOutsideClick";

import styles from "./dropdown-menu.module.scss";

export interface DropDownMenuOptionInterface {
  icon?: string;
  label: string;
  action?: () => void;
}

interface DropdownMenuInterface {
  options: DropDownMenuOptionInterface[];
  isActive: boolean;
  onClick: (option) => void;
  customMenu?: any;
}

const DropdownMenu = ({
  options,
  isActive,
  onClick,
  customMenu
}: DropdownMenuInterface) => {
  const ref = useOutsideClick(onClick, isActive);
  const optionClick = (e, option) => {
    e.stopPropagation();
    onClick(option);
  };
  useEffect(() => {
    const handleResize = () => {
      const dropdown = ref.current;
      const rect = dropdown.getBoundingClientRect();
      const windowHeight = document.documentElement.scrollHeight;
      const windowWidth = document.documentElement.clientWidth;
      //IMPORTANT paddings stored in container mixin
      const containerPadding =
        windowWidth > 1300 ? 40 : windowWidth > 992 ? 20 : 10;

      if (rect.top + rect.bottom > windowHeight) {
        dropdown.style.bottom = `${
          dropdown.parentElement.clientHeight + rect.height + 6
        }px`;
      }

      if (rect.right > windowWidth) {
        dropdown.style.left = `${
          windowWidth - rect.right - containerPadding
        }px`;
      }
    };

    // Initial call to handleResize to set initial positions
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [ref]);

  return (
    <div
      className={cn(styles["dropdown"], {
        [styles["dropdown--active"]]: isActive
      })}
      ref={ref}
    >
      {customMenu && customMenu}
      {options &&
        options.map((item, i) => {
          return (
            <div
              className={styles["option"]}
              key={`option${i}`}
              onClick={(e) => optionClick(e, item)}
            >
              {item.icon && (
                <div className={styles["option-icon"]}>
                  <img src={item.icon} alt={`{item.label}-icon`} />
                </div>
              )}
              {item.label}
            </div>
          );
        })}
    </div>
  );
};

export default DropdownMenu;
